import { Box } from '@mui/material';
import NotesPane from './NotesPane';
import ReviewPane from './ReviewPane';
import { CallDto } from '@act/shared/data-transfer-objects';

interface ContentPanelProps {
  voiceCall: CallDto;
}

const ContentPaneContainer = ({ children }) => (
  <Box
    sx={{
      flex: 1,
      height: '100%',
      padding: 2,
      border: '1px solid #DCE4E8',
      borderRadius: '8px',
      background: '#FBFCFE',
      boxSizing: 'border-box',
    }}
  >
    {children}
  </Box>
);

export const ContentPanel = ({ voiceCall }: ContentPanelProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 3,
        padding: '0 4px',
        height: '100%',
        minHeight: 0,
        boxSizing: 'border-box',
      }}
    >
      <ContentPaneContainer>
        <NotesPane voiceCall={voiceCall} />
      </ContentPaneContainer>
      <ContentPaneContainer>
        <ReviewPane voiceCall={voiceCall} />
      </ContentPaneContainer>
    </Box>
  );
};
